import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const BookingReceived = () => (
  <div className="min-h-screen bg-[#F5F1E8] py-16 px-6" data-testid="booking-received-page">
    <div className="max-w-2xl mx-auto">
      <Card className="border-2 border-[#8B7355]/20 shadow-2xl">
        <CardContent className="p-10 text-center">
          <div className="mx-auto w-20 h-20 rounded-full bg-[#C9A961]/20 flex items-center justify-center mb-6">
            <CheckCircle2 className="w-12 h-12 text-[#C9A961]" />
          </div>
          <h1 className="text-4xl font-serif text-[#8B7355] mb-3 italic">Enquiry Received</h1>
          <p className="text-lg text-[#8B7355]/80 mb-8">
            Thanks for reaching out — your date is pencilled in and we&apos;ll be in touch shortly.
          </p>

          <div className="bg-[#F5F1E8] border border-[#8B7355]/20 rounded-lg p-6 mb-8 text-left space-y-4">
            <div className="flex items-start gap-3">
              <Phone className="w-6 h-6 text-[#C9A961] mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-serif text-[#8B7355] text-lg">We&apos;ll call you within 24 hours</p>
                <p className="text-sm text-[#8B7355]/70">To confirm your booking, answer any questions, and arrange your deposit.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Mail className="w-6 h-6 text-[#C9A961] mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-serif text-[#8B7355] text-lg">Check your inbox</p>
                <p className="text-sm text-[#8B7355]/70">
                  We&apos;ve just sent you a copy of your quote — check your spam folder if you don&apos;t see it in a few minutes.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button
                variant="outline"
                className="border-[#8B7355] text-[#8B7355] hover:bg-[#8B7355] hover:text-white rounded-none font-serif px-8"
                data-testid="back-home-btn"
              >
                Back to Home
              </Button>
            </Link>
          </div>

          <p className="text-xs text-[#8B7355]/60 mt-8 italic">
            Need to reach us urgently? Reply to the confirmation email and we&apos;ll respond as soon as possible.
          </p>
        </CardContent>
      </Card>
    </div>
  </div>
);

export default BookingReceived;
